import React from 'react';
import {Card1} from '../cards/card-1';
import {Card2} from '../cards/card-2';
import {Card3} from '../cards/card-3';

export function getIdMirrorCards(
  darkRefs: React.RefObject<HTMLDivElement>[],
  lightRefs: React.RefObject<HTMLDivElement>[],
  isMobileCard: boolean = false,
) {
  return [
    <Card1
      cardInfoDarkRef={darkRefs[0]}
      cardInfoLightRef={lightRefs[0]}
      isMobileCard={isMobileCard}
    />,
    <Card2
      cardInfoDarkRef={darkRefs[1]}
      cardInfoLightRef={lightRefs[1]}
      isMobileCard={isMobileCard}
    />,
    <Card3
      cardInfoDarkRef={darkRefs[2]}
      cardInfoLightRef={lightRefs[2]}
      isMobileCard={isMobileCard}
    />,
  ];
}
